const getters = { 
    active: state => state.app.active,
    navHeight: state => state.app.navHeight,
    isPc: state => state.app.isPc
};

export default getters;